module.exports = __webpack_public_path__ + "img/13.0a120421.png";